/* ==========================================================================
   ROYAL ROASTERY  ·  rr-theme.js  ·  v5
   No framework, no build step. Everything degrades to a working page if this
   file fails to load: all content is server rendered and every link is real.
   ========================================================================== */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* Sections 7 (collection filter) and 10 (horizontal rails) were removed on 2026-08-20: their selectors no longer exist in the theme. Numbering left unchanged on purpose. */

  /* ------------------------------------------------------------------
     1. Mobile navigation
     ------------------------------------------------------------------ */
  var navToggle = $('[data-rr-navtoggle]');
  var mobileNav = $('#rr-mobilenav');
  if (navToggle && mobileNav) {
    navToggle.addEventListener('click', function () {
      var open = mobileNav.getAttribute('data-open') === 'true';
      mobileNav.setAttribute('data-open', open ? 'false' : 'true');
      navToggle.setAttribute('aria-expanded', open ? 'false' : 'true');
      navToggle.setAttribute('aria-label', open ? 'Open menu' : 'Close menu');
    });
  }

  /* ------------------------------------------------------------------
     2. Ticker. Pause on demand and when off screen.
     ------------------------------------------------------------------ */
  $$('[data-rr-ticker]').forEach(function (ticker) {
    var btn = $('[data-rr-ticker-toggle]', ticker);
    if (btn) {
      btn.addEventListener('click', function () {
        var paused = ticker.getAttribute('data-paused') === 'true';
        ticker.setAttribute('data-paused', paused ? 'false' : 'true');
        btn.textContent = paused ? 'Pause' : 'Play';
        btn.setAttribute('aria-label', paused ? 'Pause the scrolling banner' : 'Play the scrolling banner');
      });
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (ticker.getAttribute('data-paused') === 'true') return;
          var run = $('.rr-run', ticker);
          if (run) run.style.animationPlayState = e.isIntersecting ? 'running' : 'paused';
        });
      }, { threshold: 0 }).observe(ticker);
    }
  });

  /* ------------------------------------------------------------------
     3. Scroll reveals. Blur to focus, once, staggered.
     ------------------------------------------------------------------ */
  if (!reduce && 'IntersectionObserver' in window) {
    var revealTargets = $$('.rr-section > *, .rr-reveal');
    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry, i) {
        if (!entry.isIntersecting) return;
        setTimeout(function () { entry.target.classList.add('is-in'); }, i * 90);
        obs.unobserve(entry.target);
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
    revealTargets.forEach(function (el) {
      if (el.classList.contains('rr-reveal')) io.observe(el);
    });
  } else {
    $$('.rr-reveal').forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ------------------------------------------------------------------
     4. Tabs.  Seasonal treats and anything else using role=tablist.
     ------------------------------------------------------------------ */
  $$('[data-rr-tabs]').forEach(function (bar) {
    var tabs = $$('[role="tab"]', bar);
    function select(tab) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.setAttribute('tabindex', on ? '0' : '-1');
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) { if (on) { panel.removeAttribute('hidden'); } else { panel.setAttribute('hidden', ''); } }
      });
    }
    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { select(tab); });
      tab.addEventListener('keydown', function (e) {
        var next = null;
        if (e.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
        if (e.key === 'ArrowLeft')  next = tabs[(i - 1 + tabs.length) % tabs.length];
        if (e.key === 'Home')       next = tabs[0];
        if (e.key === 'End')        next = tabs[tabs.length - 1];
        if (next) { e.preventDefault(); select(next); next.focus(); }
      });
    });
  });

  /* ------------------------------------------------------------------
     5. Simple occasion / category filter bars (cakes, press).
     ------------------------------------------------------------------ */
  $$('[data-rr-filterbar]').forEach(function (bar) {
    var scope = bar.closest('section') || document;
    var grid  = $('[data-rr-filtergrid]', scope);
    var empty = $('[data-rr-filterempty]', scope);
    if (!grid) return;
    var items = Array.prototype.slice.call(grid.children);

    $$('[data-rr-filter]', bar).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-rr-filter');
        $$('[data-rr-filter]', bar).forEach(function (b) { b.setAttribute('aria-selected', b === btn ? 'true' : 'false'); });
        var shown = 0;
        items.forEach(function (el) {
          var occ = (el.getAttribute('data-occasion') || '').split(/\s+/);
          var on = key === 'all' || occ.indexOf(key) !== -1;
          el.hidden = !on;
          if (on) shown++;
        });
        if (empty) { if (shown === 0) { empty.removeAttribute('hidden'); } else { empty.setAttribute('hidden', ''); } }
      });
    });
  });

  /* ------------------------------------------------------------------
     6. Full menu.  Branch, category, and instant search.
        No page reloads. Result count is announced.
     ------------------------------------------------------------------ */
  var menuRoot = $('[data-rr-menu]');
  if (menuRoot) {
    var selBranch = $('[data-rr-menu-branch]', menuRoot);
    var selCat    = $('[data-rr-menu-cat]', menuRoot);
    var inputQ    = $('[data-rr-menu-q]', menuRoot);
    var countEl   = $('[data-rr-menu-count]', menuRoot);
    var emptyEl   = $('[data-rr-menu-empty]', menuRoot);

    function applyMenu() {
      var branch = selBranch ? selBranch.value : '';
      var cat    = selCat ? selCat.value : 'all';
      var q      = inputQ ? inputQ.value.trim().toLowerCase() : '';
      var total  = 0;

      $$('[data-rr-branchpanel]', menuRoot).forEach(function (p) {
        p.hidden = p.getAttribute('data-rr-branchpanel') !== branch;
      });

      $$('[data-rr-branchmenu]', menuRoot).forEach(function (bm) {
        var isBranch = bm.getAttribute('data-rr-branchmenu') === branch;
        bm.hidden = !isBranch;
        if (!isBranch) return;

        $$('[data-rr-group]', bm).forEach(function (group) {
          var groupCat = group.getAttribute('data-cat');
          var catOk = (cat === 'all' || cat === groupCat);
          var visible = 0;

          $$('[data-rr-item]', group).forEach(function (item) {
            var name = item.getAttribute('data-name') || '';
            var desc = item.getAttribute('data-desc') || '';
            var match = q === '' || name.indexOf(q) !== -1 || desc.indexOf(q) !== -1;
            var on = catOk && match;
            item.hidden = !on;
            if (on) visible++;
          });

          group.hidden = visible === 0;
          total += visible;
        });
      });

      if (countEl) countEl.textContent = total + (total === 1 ? ' item' : ' items');
      if (emptyEl) { if (total === 0) { emptyEl.removeAttribute('hidden'); } else { emptyEl.setAttribute('hidden', ''); } }
    }

    [selBranch, selCat].forEach(function (el) { if (el) el.addEventListener('change', applyMenu); });
    if (inputQ) {
      var t;
      inputQ.addEventListener('input', function () { clearTimeout(t); t = setTimeout(applyMenu, 140); });
    }
    applyMenu();
  }

  /* ------------------------------------------------------------------
     8. Order dialog. One root, opened by any trigger on the page.
        Focus trap, Escape, backdrop close, focus restored to the opener.
     ------------------------------------------------------------------ */
  var dlg      = $('.rr-dialog');
  var dlgBack  = $('.rr-dialog-backdrop');
  var dlgTitle = $('#rr-dialog-title');
  var dlgBranch= $('[data-rr-dialog-branch]');
  var dlgLinks = $('[data-rr-dialog-links]');
  var lastOpener = null;

  function focusables() {
    return $$('a[href], button:not([disabled]), select, input, [tabindex]:not([tabindex="-1"])', dlg)
      .filter(function (el) { return el.offsetParent !== null; });
  }

  function openDialog(trigger) {
    if (!dlg) return;
    lastOpener = trigger;
    var branch = trigger.getAttribute('data-branch') || '';
    var dd = trigger.getAttribute('data-dd') || '';
    var ue = (trigger.getAttribute('data-ue') || '').trim();
    /* COMING_SOON is a sentinel carried in the location data, not a URL: the
       branch gets Uber Eats later. Trimmed and upper cased so a stray space or
       lower case still reaches the coming soon state instead of a dead link. */
    var ueKey = ue.toUpperCase();
    var shop = trigger.getAttribute('data-shop') || '';

    if (dlgTitle) dlgTitle.textContent = 'Order Online';
    if (dlgBranch) dlgBranch.textContent = branch ? 'From ' + branch : '';

    var html = '';
    if (dd)  html += '<a href="' + dd + '" rel="noopener" target="_blank">DoorDash</a>';
    if (!ue || ueKey === 'COMING_SOON') { html += '<span>Uber Eats · Coming Soon</span>'; }
    else { html += '<a href="' + ue + '" rel="noopener" target="_blank">Uber Eats</a>'; }
    if (shop) html += '<a href="' + shop + '">Shop Online</a>';
    if (dlgLinks) dlgLinks.innerHTML = html;

    dlg.removeAttribute('hidden');
    if (dlgBack) dlgBack.removeAttribute('hidden');
    document.body.classList.add('rr-dialog-open');
    document.body.style.overflow = 'hidden';
    var f = focusables();
    if (f.length) f[0].focus();
  }

  function closeDialog() {
    if (!dlg) return;
    document.body.classList.remove('rr-dialog-open');
    document.body.style.overflow = '';
    window.setTimeout(function () {
      dlg.setAttribute('hidden', '');
      if (dlgBack) dlgBack.setAttribute('hidden', '');
    }, 240);
    if (lastOpener) { lastOpener.focus(); lastOpener = null; }
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest ? e.target.closest('[data-rr-order]') : null;
    if (trigger) { e.preventDefault(); openDialog(trigger); return; }
    if (e.target.closest && e.target.closest('[data-rr-dialog-close]')) { e.preventDefault(); closeDialog(); }
  });

  document.addEventListener('keydown', function (e) {
    if (!document.body.classList.contains('rr-dialog-open')) return;
    if (e.key === 'Escape') { closeDialog(); return; }
    if (e.key === 'Tab') {
      var f = focusables();
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ------------------------------------------------------------------
     9. Branch page delivery select. Opens the chosen app in a new tab.
     ------------------------------------------------------------------ */
  $$('[data-rr-delivery]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      if (sel.value) { window.open(sel.value, '_blank', 'noopener'); sel.selectedIndex = 0; }
    });
  });

})();

/* ==========================================================================
   Motion gallery: endless drag, swipe, buttons, keyboard, filters.
   Appended as a separate IIFE so a failure here cannot break the rest.
   ========================================================================== */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  $$('[data-rr-drag]').forEach(function (rail) {
    var scope = rail.closest('section') || document;
    var track = $('[data-rr-drag-track]', rail);
    if (!track) return;
    var items = $$('.rr-drag-item', track);

    /* --- pointer drag, desktop and touch ------------------------------- */
    var down = false, startX = 0, startScroll = 0, moved = 0;
    rail.addEventListener('pointerdown', function (e) {
      if (e.target.closest('a, button, video, iframe, select, input')) return;
      down = true; moved = 0;
      startX = e.clientX; startScroll = rail.scrollLeft;
      rail.setAttribute('data-grabbing', 'true');
      rail.setPointerCapture(e.pointerId);
    });
    rail.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      moved = Math.abs(dx);
      rail.scrollLeft = startScroll - dx;
    });
    ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (evt) {
      rail.addEventListener(evt, function (e) {
        if (!down) return;
        down = false;
        rail.removeAttribute('data-grabbing');
        try { rail.releasePointerCapture(e.pointerId); } catch (err) {}
      });
    });
    /* Swallow the click that ends a real drag so links do not fire. */
    rail.addEventListener('click', function (e) {
      if (moved > 8) { e.preventDefault(); e.stopPropagation(); moved = 0; }
    }, true);

    /* --- previous and next --------------------------------------------- */
    function step(dir) {
      var first = $('.rr-drag-item:not([hidden])', track);
      var w = first ? first.getBoundingClientRect().width + 18 : Math.round(rail.clientWidth * 0.8);
      var count = Math.max(1, Math.floor(rail.clientWidth / w));
      rail.scrollBy({ left: dir * w * count, behavior: reduce ? 'auto' : 'smooth' });
    }
    var prev = $('[data-rr-drag-prev]', scope);
    var next = $('[data-rr-drag-next]', scope);
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });

    /* --- keyboard ------------------------------------------------------- */
    rail.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); step(1); }
      if (e.key === 'ArrowLeft')  { e.preventDefault(); step(-1); }
      if (e.key === 'Home') { e.preventDefault(); rail.scrollTo({ left: 0, behavior: reduce ? 'auto' : 'smooth' }); }
      if (e.key === 'End')  { e.preventDefault(); rail.scrollTo({ left: rail.scrollWidth, behavior: reduce ? 'auto' : 'smooth' }); }
    });

    /* --- motion stagger on entry ---------------------------------------- */
    if (!reduce && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (en, i) {
          if (!en.isIntersecting) return;
          setTimeout(function () { en.target.classList.add('is-in'); }, i * 80);
          obs.unobserve(en.target);
        });
      }, { root: null, threshold: 0.12 });
      items.forEach(function (it) { io.observe(it); });
    } else {
      items.forEach(function (it) { it.classList.add('is-in'); });
    }

    /* --- filters --------------------------------------------------------- */
    var bar = $('[data-rr-dragfilter]', scope);
    var empty = $('[data-rr-dragempty]', scope);
    if (bar) {
      $$('[data-rr-filter]', bar).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var key = btn.getAttribute('data-rr-filter');
          $$('[data-rr-filter]', bar).forEach(function (b) {
            b.setAttribute('aria-selected', b === btn ? 'true' : 'false');
          });
          var shown = 0;
          items.forEach(function (it) {
            var on = key === 'all' || it.getAttribute('data-occasion') === key;
            it.hidden = !on;
            if (on) { shown++; it.classList.add('is-in'); }
          });
          if (empty) { if (shown === 0) empty.removeAttribute('hidden'); else empty.setAttribute('hidden',''); }
          rail.scrollTo({ left: 0, behavior: reduce ? 'auto' : 'smooth' });
        });
      });
    }
  });
})();
